import { createSuite } from "../_snowpack/pkg/@benchristel/taste.js";
export const integrationSuite = createSuite();
export const integrationTest = integrationSuite.test;
